import { Grid, Stack, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";

import { useState } from "react";
import { useEffect } from "react";
import CategoryItem from "./CategoryItem";
import { categoryApi } from "../../API/Api";
const Categories = () => {
  let setCaten = `[{"banner_pic":"https:\/\/ap.songjukti.com\/image\/catPic\/creative_work.jpg","title":"Graphics Design","type":"Graphics Design","info":"Brand Your Business","subcat":"","total_listing":"164","category":"IJUWS5BE","refer":"1","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/web_event\/catering.jpg","title":"Event","type":"International Corporate Event Organization","info":"Event Design & Organization","subcat":"","total_listing":"25","category":"TPKHNME3","refer":"6","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/web_writing\/article_writing.jpg","title":"Writing","type":"Article Writing","info":"Article Writing","subcat":"","total_listing":"16","category":"48DG1PDD","refer":"8","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/web_marketing\/promotion.jpg","title":"Brand Promotion","type":"Promotion","info":"Promoting business by brand expert","subcat":"","total_listing":"32","category":"LY1KJ2GA","refer":"7","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/web_mobile\/android_native.jpg","title":"Nativ Android App","type":"Native App","info":"Build awesome native app for android OS","subcat":"","total_listing":"9","category":"91LQABKQ","refer":"3","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/catPic\/creative_work.jpg","title":"Flayer Print","type":"DTP","info":"Give your promotional materials a professional edge. Show off your brand in two sides of full colour \u2013 in matte or full gloss finish.","subcat":"","total_listing":"43","category":"D8PKL7VI","refer":"5","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/web_law\/taxaion.jpg","title":"Income Tax expert","type":"Lawyer","info":"Pay your tax with an authorised Income tax Lawyer","subcat":"","total_listing":"15","category":"7JF45AQ4","refer":"9","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/web_photograph\/model_photo.jpg","title":"Model Photography","type":"Model Photography","info":"Wanna find a photgrapher for your modeling","subcat":"","total_listing":"29","category":"FI9UXNVY","refer":"11","state":"1"},{"banner_pic":"https:\/\/ap.songjukti.com\/image\/web_admin\/cms.jpg","title":"Web Manager","type":"Web Admin","info":"Get a creative & dynamic Web manager to manage your website","subcat":"","total_listing":null,"category":"SYQN7WBB","refer":"17","state":"1"}]
`;
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    fetch("https://ghorami.com/profile/login/api_webland/top_category.php", {
      method: "GET",
    })
      .then((res) => res.text()) // Use .text() first to debug raw response
      .then((text) => {
        try {
          const json = JSON.parse(text);
          setCategoryData(json ?? setCaten);
        } catch (err) {
          console.error("JSON parse error", err);
        }
      })
      .catch((error) => console.log("Fetch Error => ", error));
  }, []);

  return (
    <Container>
      {categoryData.length > 1 && (
        <Box mt={8} sx={{ background: "transparent" }}>
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{
              px: 2,
              textAlign: "center",
              gap: 1.5,
              mb: 4,
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "26pt", md: "34pt" },
                background: "linear-gradient(to right, #00C9A7, #0074E4)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                letterSpacing: "0.5px",
              }}
            >
              Trending Top Categories
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "13pt", md: "15pt" },
                color: "#9E9E9E",
                maxWidth: "600px",
              }}
            >
              Largest globally spread network of talented people
            </Typography>
          </Stack>

          <Grid container spacing={2} mt={1} sx={{ marginTop: "-25px" }}>
            {categoryData.map((element) => (
              <Grid item xs={6} sm={4} md={4} lg={4} key={element.refer}>
                <CategoryItem data={element} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Container>
  );
};

export default Categories;
